// extracted by mini-css-extract-plugin
module.exports = {"overlayContainer":"styles_overlayContainer__1hjEn","itemBox":"styles_itemBox__1_1W1","searchText":"styles_searchText__2q900","typeOfFile":"styles_typeOfFile__1JftJ"};